<template>
  <div
    id="element"
    class="home-container"
  >
    <div class="home-container-item">
      <Header/>
    </div>
    <div class="home-container-item">
      <div class="has-padding--mobile">
        <div class="columns is-tablet">
          <div class="column is-10 is-offset-1">
            <FullLabel
              v-if="!isCorrectNetworK"
              :text="$t('messages.wrong_eth_network', [getTheCorrectNetwork()])"
            />
            <div class="home-column-right">
              <div v-if="!isWalletConnected">
                <WalletConnector/>
              </div>
              <div v-else>
                <UserAssets ref="UserAssets"/>
              </div>
            </div>
            <div class="home-column-left">
              <Trading
                @onCompleteTreading="onCompleteTreading"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="home-container-item token-profiles-container"
      data-test="exchagne--token-profile"
    >
      <div class="has-padding--mobile">
        <div class="columns is-tablet">
          <div class="column is-10 is-offset-1">
            <!-- <TokenProfile
              @onCompleteTreading="onCompleteTreading"
            /> -->
          </div>
        </div>
        <div
          v-scroll-to="'#element'"
          v-show="visibleBackToTop"
          :class="['back-to-top', {'swap-to-sticky': isSwapToSticky }]"
        >
          <img src="/static/svg/icon-backtotop-desktop.svg">
        </div>
      </div>
    </div>
    <div class="home-container-item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from '@/features/Header'
import Footer from '@/components/Footer'
import FullLabel from '@/components/FullLabel'
import WalletConnector from '@/features/WalletConnector'
import Trading from '@/features/Trading'
import UserAssets from '@/features/UserAssets'
import TokenProfile from '@/features/TokenProfile'
import TopTrader from '@/features/TopTrader'
import Service from './service.js'
import KulapService from '@/services/kulap'
import { getCorrectNetwork } from '@/environments'
import { kulapApi } from '@/resources'
import { mapState } from 'vuex'
export default {
  name: 'Exchange',
  components: {
    Header,
    UserAssets,
    FullLabel,
    WalletConnector,
    TokenProfile,
    Trading,
    TopTrader,
    Footer
  },
  data () {
    return {
      service: null,
      visibleoffset: 700,
      visibleBackToTop: false,
      isCorrectNetworK: true,
      isSwapToSticky: false
    }
  },
  computed: {
    ...mapState({
      isWalletConnected: state => state.isWalletConnected,
      currentNetwork: state => state.currentNetwork
    })
  },
  async created () {
    const kulapDex = new KulapService()
    await kulapDex.init()
    this.service = new Service({
      store: this.$store,
      kulapApi,
      kulapDex
    })
    this.connectInjectedWeb3()
    await this.initialInterface()
  },
  mounted () {
    window.smoothscroll = () => {
      let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll)
        window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)))
      }
    }
    window.addEventListener('scroll', this.catchScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.catchScroll)
  },
  methods: {
    getTheCorrectNetwork () {
      const network = getCorrectNetwork()
      return network.charAt(0).toUpperCase() + network.slice(1)
    },
    async initialInterface () {
      await this.service.getTokensAvaliable()
      await this.service.getAssetsProfile()
    },
    async connectInjectedWeb3 () { // Interval for check Metamask connection.
      await this.service.updateCurrentProvider()
    },
    onCompleteTreading () {
      this.$refs.UserAssets.calculateUserAssets()
    },
    catchScroll () {
      this.visibleBackToTop = (window.pageYOffset > parseInt(this.visibleoffset))
      this.isSwapToSticky = Boolean(window.pageYOffset > parseInt(document.body.clientHeight - 1100))
    }
  }
}
</script>

<style scoped>
.home-container {
  float: left;
  width: 100%;
  min-height: 100vh;
}
.home-container-item {
  float: left;
  width: 100%;
}
.home-column-right {
  float: right;
  width: 49%;
  margin-left: 1%;
}
.home-column-left {
  float: right;
  width: 49%;
  margin-right: 1%;
}
.token-profiles-container {
  margin-top: 65px;
}
.back-to-top img {
 position: fixed;
  top: 90%;
  left: 92%;
  cursor: pointer;
  width: 55px;
  height: 55px;
}
.swap-to-sticky img {
  position: sticky;
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .home-column-right {
    float: left;
    width: 100%;
    margin: 0 0 15px 0;
  }
  .home-column-left {
    float: left;
    width: 100%;
    margin: 15px 0 0 0;
  }
  .token-profiles-container {
    margin-top: 40px;
  }
  .back-to-top img {
    left: 90%;
    width: 40px;
    height: 40px;
    opacity: 1;
    z-index: 10;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .back-to-top img {
    left: 85%;
  }
  .token-profiles-container {
    margin-top: 20px;
  }
  .home-column-left {
    float: left;
    width: 100%;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Exchange/index.vue